import React, { useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";

const Pagination = ({ currentPage, totalPages, onPageChange, pageWindow = 2 }) => {
  const [inputPage, setInputPage] = useState(currentPage);

  if (!totalPages || totalPages <= 1) return null;

  const handlePreviousPage = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  const handlePageInputChange = (e) => {
    const value = parseInt(e.target.value);
    if (!isNaN(value) && value >= 1 && value <= totalPages) {
      setInputPage(value);
    }
  };

  const handlePageInputSubmit = (e) => {
    e.preventDefault();
    const value = parseInt(inputPage);
    if (!isNaN(value) && value >= 1 && value <= totalPages) {
      onPageChange(value);
    } else {
      setInputPage(currentPage);
    }
  };

  const start = Math.max(1, currentPage - pageWindow);
  const end = Math.min(totalPages, currentPage + pageWindow);
  const pages = Array.from({ length: end - start + 1 }, (_, i) => start + i);

  return (
    <div className="pagination-controls d-flex align-items-center justify-content-end gap-2">
      <Button
        variant="outline-primary"
        disabled={currentPage === 1}
        onClick={handlePreviousPage}
        className="px-3"
        size="sm"
      >
        Previous
      </Button>

      {start > 1 && (
        <>
          <Button
            variant={currentPage === 1 ? "primary" : "outline-secondary"}
            className="px-3"
            onClick={() => onPageChange(1)}
            size="sm"
          >
            1
          </Button>
          {start > 2 && <span className="text-muted">…</span>}
        </>
      )}

      {pages.map((page) => (
        <Button
          key={page}
          variant={page === currentPage ? "primary" : "outline-secondary"}
          className="px-3"
          onClick={() => onPageChange(page)}
          size="sm"
        >
          {page}
        </Button>
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="text-muted">…</span>}
          <Button
            variant={currentPage === totalPages ? "primary" : "outline-secondary"}
            className="px-3"
            onClick={() => onPageChange(totalPages)}
            size="sm"
          >
            {totalPages}
          </Button>
        </>
      )}

      <Button
        variant="outline-primary"
        disabled={currentPage === totalPages}
        onClick={handleNextPage}
        className="px-3"
        size="sm"
      >
        Next
      </Button>

      {totalPages > 10 && (
        <Form onSubmit={handlePageInputSubmit} className="d-flex align-items-center gap-2">
          <InputGroup size="sm" style={{ width: '80px' }}>
            <Form.Control
              type="number"
              value={inputPage}
              onChange={handlePageInputChange}
              min={1}
              max={totalPages}
              className="text-center"
            />
          </InputGroup>
          <Button variant="outline-secondary" size="sm" type="submit">
            Go
          </Button>
        </Form>
      )}
    </div>
  );
};

export default Pagination;
